// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { IConfig, IConfiguration } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

import { sessionExpirationMs } from './constants';
import history from 'src/history';
import Environment from './../../environments';

const reactPlugin = new ReactPlugin();

export const defaultAppInsightsConfig = {
    // A session is logged if it has continued for this amount of time in milliseconds. Default is 24 hours = 86400000
    sessionExpirationMs,
    disableAjaxTracking: false, // Default is false, may want to disable if we need to manually send dependency data
    disableFetchTracking: false,
    disableCorrelationHeaders: true, // Disable auto-adding request-id since HttpService will set it to the cv
    enableAutoRouteTracking: false, // Don't need since ReactPlugin tracks pages via history, and setting to true results in duplicate logs.
    enableCorsCorrelation: true,
    enableDebugExceptions: Environment.production !== true, // Only show telemetry warnings/exceptions in non-prod
    endpointUrl: Environment.telemetryUrl,
    extensionConfig: {
        [reactPlugin.identifier]: { history },
    },
    extensions: [reactPlugin],
    instrumentationKey: Environment.telemetryKey,
    maxBatchInterval: 0,
    samplingPercentage: 100,
} as IConfiguration & IConfig; // The expected type for App Insights constructor's config parameter

export default defaultAppInsightsConfig;
